import React from "react";
import { CcIconReport } from "../../icons";
import CcIconButton from "../mui/CcIconButton";

/**
 * Standard icon-only report action for data tables and toolbars.
 * Uses CcIconButton secondary styling with the Zen editorial CcIconReport.
 */
const CcReportButton = ({
  label = "Report",
  onClick,
  size = "sm",
  variant = "secondary",
  disabled = false,
  stopPropagation = true,
  type = "button",
  className,
}) => {
  const handleClick = (event) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    onClick?.(event);
  };

  return (
    <CcIconButton
      type={type}
      label={label}
      variant={variant}
      size={size}
      disabled={disabled}
      className={className}
      onClick={handleClick}
    >
      <CcIconReport size={18} />
    </CcIconButton>
  );
};

export default CcReportButton;
